// File: src/components/common/DeliveryPopup.jsx
import React from "react";
import { X, MapPin } from "lucide-react";
import location_icon from "../../assets/images/location_icon.png";
import { useTranslation } from "react-i18next";


const DeliveryQRLocPopup = ({
  isOpen,
  onClose,
  location,
  building,
  qrImage, // replace with real QR src
  numbers,
}) => {
  const { t, i18n } = useTranslation();
  
  if (!isOpen) return null;
  

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-white rounded-2xl w-full max-w-sm p-6 relative shadow-xl">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-red-500 hover:scale-110 transition"
        >
          <X size={22} />
        </button>

        {/* Location & Building */}
        <div className="space-y-2 mb-5 flex flex-col items-center text-center">
          <div className="flex items-center">
            <span className="text-gray-500 text-sm w-20">{t("locations")}:</span>
            <span className="text-[#2699FF] font-semibold text-sm">
              {location}
            </span>
          </div>
          <div className="flex items-center">
            <span className="text-gray-500 text-sm w-20">{t("buildings")}:</span>
            <span className="text-[#2699FF] font-semibold text-sm">
              {building}
            </span>
          </div>
        </div>

        {/* Delivery Location Button */}
        <div className="flex justify-center mb-6">
          <button className="flex items-center gap-2 px-5 py-2 bg-[#2699FF] text-white rounded-xl font-medium shadow">
            {t("deliveryLocation")}
            <img
              src={location_icon}
              alt="QR Code"
              className="w-5 h-5 object-contain"
            />
            {/* <MapPin size={16} /> */}
          </button>
        </div>

        {/* QR Code */}
        <div className="flex justify-center mb-4">
          <img
            src={qrImage}
            alt="QR Code"
            className="w-48 h-48 object-contain"
          />
        </div>

        {/* OR */}
        <div className="text-center text-gray-400 text-sm font-medium mb-4">
          {t("or")}
        </div>

        {/* OTP Boxes */}
        <div className="flex justify-center gap-3 mb-2">
          {numbers.map((num, index) => (
            <div
              key={index}
              className="w-9 h-10 border border-gray-300 rounded-md flex items-center justify-center"
            >
              <span className="text-base font-semibold">{num}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DeliveryQRLocPopup;
